import React from "react";
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import Routage from "./Routage";

function App() {
  return (
    <div className="">
      <NavigationBar />
      <Routage />
      <Footer />
    </div>
  );
}

export default App;
